import React, { useState, useMemo } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { FaExternalLinkAlt } from "react-icons/fa";
import ZoomImage from "../common/ZoomImage";
import flagNetherlands from "../../images/main/flag-netherlands.svg";
import flagBelgium from "../../images/main/flag-belgium.svg";
import "../../css/orders/orders.css";

const countryCodeToName = (cc) => (cc === "NL" ? "Nederland" : cc === "BE" ? "België" : cc);

const CountryFlag = ({ code }) => {
  if (code === "NL") return <img src={flagNetherlands} alt="NL" />;
  if (code === "BE") return <img src={flagBelgium} alt="BE" />;
  return <>{code}</>;
};

const OrderListItemsBolShipStep3 = ({ order, index }) => {
  const [showAlertText, setShowAlertText] = useState("");

  const animateAlertText = (text) => {
    setShowAlertText(text);
    setTimeout(() => setShowAlertText(""), 3000);
  };

  const addressText = useMemo(() => {
    if (!order?.shipmentDetails) return "";
    const s = order.shipmentDetails;
    const companyLine = s.company ? s.company + "\n" : "";
    const nameLine = `${s.firstName || ""} ${s.surname || ""}`.trim() + "\n";
    const streetLine =
      `${s.streetName || ""} ${s.houseNumber || ""}` +
      (s.houseNumberExtension ? " " + s.houseNumberExtension : "") +
      "\n";
    const cityLine = `${s.zipCode || ""} ${s.city || ""}`.trim() + "\n";
    const countryLine = countryCodeToName(s.countryCode || "");
    return companyLine + nameLine + streetLine + cityLine + countryLine;
  }, [order]);

  if (!order?.orderItems?.length) return null;

  const visibleItems = order.orderItems.filter((oi) => oi?.checked);

  return (
    <div className="o-li-item o-li-item-ship-bol-step-3">
      <div className="o-li-item-ship-bol-step-3-col1">
        <div className="o-li-item-index">{(index ?? 0) + 1}</div>
        <div className="o-li-item-country-flag">
          <CountryFlag code={order?.shipmentDetails?.countryCode} />
        </div>
        <div className="o-li-item-orderNumber">
          <span>#</span>
          {order?.orderId}
        </div>
      </div>

      <div className="o-li-item-address">
        <CopyToClipboard text={addressText} onCopy={() => animateAlertText("Gekopieerd")}>
          <div>
            {order?.shipmentDetails?.company && (
              <>
                <span className="o-li-item-address-name">{order.shipmentDetails.company}</span>
                <br />
              </>
            )}
            {!order?.shipmentDetails?.company && (
              <>
                <span className="o-li-item-address-name">
                  {(order?.shipmentDetails?.firstName || "") + " " + (order?.shipmentDetails?.surname || "")}
                </span>
                <br />
              </>
            )}
            {(order?.shipmentDetails?.streetName || "") +
              " " +
              (order?.shipmentDetails?.houseNumber || "") +
              (order?.shipmentDetails?.houseNumberExtension
                ? " " + order.shipmentDetails.houseNumberExtension
                : "")}
            <br />
            {(order?.shipmentDetails?.zipCode || "") + " " + (order?.shipmentDetails?.city || "")}
            <br />
            {countryCodeToName(order?.shipmentDetails?.countryCode || "")}
          </div>
        </CopyToClipboard>
      </div>

      <div className="o-li-item-content">
        {visibleItems.map((orderItem) => (
          <OrderLayoutBolShipStep3
            key={orderItem.orderItemId || `${orderItem?.offer?.reference}-${orderItem?.ean || ""}`}
            order={order}
            orderItem={orderItem}
          />
        ))}
      </div>

      <div className="o-li-item-actions">
        <div className="o-li-item-actions-shipment-method">
          {order?.frontEndChosenDeliveryOption?.displayName}
        </div>

        {order?.inputOwnReference && (
          <div className="o-li-item-actions-own-reference">
            <span>Eigen kenmerk: </span>
            {order.inputOwnReference}
          </div>
        )}

        {order?.inputTrackAndTrace && (
          <div className="o-li-item-actions-track-and-trace">
            <span>Track&Trace: </span>
            {order.inputTrackAndTrace}
          </div>
        )}
      </div>

      {showAlertText && <div className="snackbar">{showAlertText}</div>}
    </div>
  );
};

const OrderLayoutBolShipStep3 = ({ order, orderItem }) => {
  const imageUrl =
    orderItem?.productData?.image
      ? `${process.env.REACT_APP_ASSET_URL}/s3/${orderItem.productData.image}`
      : null;

      const imgKey = orderItem?.product?.productData?.image || orderItem?.productData?.image;
const imgUrl = imgKey ? `${process.env.REACT_APP_ASSET_URL}/s3/${imgKey}` : null;

  return (
    <>
      <div className="o-li-item-data-step-3-product-title">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`https://www.bol.com/nl/s/?searchtext=${orderItem?.product?.ean || ""}`}
        >
          <FaExternalLinkAlt />
        </a>
        {orderItem?.product?.title}
      </div>

      <div className="o-li-item-data-step-3">
        <div className="o-li-item-product-image-step-3 o-li-item-data-item-order-image">
          {imgUrl && (
  <ZoomImage
    src={imgUrl}                 // full-size
    thumbnailSrc={imgUrl}        // or a smaller version if you have it
    alt={orderItem?.product?.title || "Productafbeelding"}
    className="ship-step3-thumb" // optional: for your existing sizing
  />
)}
        </div>

        <div className="o-li-item-product-title-step-3"></div>

        <div className="o-li-item-data-item-step-3 o-li-item-product-quantity-step-3">
          <span>{orderItem?.quantity}</span>
        </div>

        <div className="o-li-item-data-item-step-3 o-li-item-product-reference-step-3">
          <span>
            {orderItem?.productData?.title
              ? orderItem.productData.title
              : orderItem?.offer?.reference}
          </span>
        </div>
      </div>
    </>
  );
};

export default OrderListItemsBolShipStep3;
